import { render } from "./PropertiesBar.vue?vue&type=template&id=1d05c8be"
import script from "./PropertiesBar.vue?vue&type=script&lang=js"
export * from "./PropertiesBar.vue?vue&type=script&lang=js"

import "./PropertiesBar.vue?vue&type=style&index=0&id=1d05c8be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__